export const MULTI_PSK_SECTION_EVENT =
	'canvas-agent:multi-psk:section';
export const MULTI_PSK_FILTER_EVENT =
	'canvas-agent:multi-psk:filter';
export const MULTI_PSK_FOCUS_EVENT =
	'canvas-agent:multi-psk:focus';
export const MULTI_PSK_CREATE_MODAL_EVENT =
	'canvas-agent:multi-psk:create-modal';
export const MULTI_PSK_EDIT_MODAL_EVENT =
	'canvas-agent:multi-psk:edit-modal';
export const MULTI_PSK_DELETE_MODAL_EVENT =
	'canvas-agent:multi-psk:delete-modal';
